/**
 * Checkbox/marker inventory from the last activation's clause-markup
 * validation (tagValidation.summary) — how many Word checkboxes the active
 * docx carries, how many check_ markers bind them, and how many checkboxes
 * have no marker (rendered amber: they never reflect a wizard answer).
 */

import type { TagValidation } from '../../types/orgTemplate';

interface TagSummaryStripProps {
  summary: TagValidation['summary'];
  sourceVersion: number;
}

function CountChip({ value, label, tone }: { value: number; label: string; tone: 'slate' | 'amber' }) {
  const toneClasses =
    tone === 'amber'
      ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-200 border-amber-200 dark:border-amber-800'
      : 'bg-slate-50 dark:bg-slate-700 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-600';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-body-sm ${toneClasses}`}>
      <span className="font-semibold">{value}</span>
      {label}
    </span>
  );
}

export default function TagSummaryStrip({ summary, sourceVersion }: TagSummaryStripProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <CountChip value={summary.checkboxes} label="checkboxes" tone="slate" />
      <CountChip value={summary.markers} label="markers" tone="slate" />
      {summary.unmarkedCheckboxes > 0 && (
        <CountChip value={summary.unmarkedCheckboxes} label="unmarked checkboxes" tone="amber" />
      )}
      <span className="text-caption text-slate-400 dark:text-slate-500">
        validated against v{sourceVersion}
      </span>
    </div>
  );
}
